<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="#0F285B"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.25 1.53172C24.25 0.687082 23.4749 0 22.522 0H1.97803C1.02514 0 0.25 0.687082 0.25 1.53172V22.4683C0.25 23.3129 1.02514 24 1.97803 24H22.522C23.4749 24 24.25 23.3129 24.25 22.4683V1.53172ZM1.97803 1.02115H22.522C22.8398 1.02115 23.098 1.25026 23.098 1.53172V4.7283H1.40202V1.53172C1.40202 1.25026 1.66021 1.02115 1.97803 1.02115ZM22.522 22.9789H1.97803C1.66021 22.9789 1.40202 22.75 1.40202 22.4683V5.74945H23.098V22.4683C23.098 22.75 22.8398 22.9789 22.522 22.9789Z"
    />
    <path
      d="M3.22005 16.0367H9.36377C9.68215 16.0367 9.93978 15.8084 9.93978 15.5262V7.97673C9.93978 7.69477 9.68215 7.46616 9.36377 7.46616H3.22005C2.90167 7.46616 2.64404 7.69477 2.64404 7.97673V15.5262C2.64404 15.8084 2.90167 16.0367 3.22005 16.0367ZM3.79606 8.48731H8.78776V15.0156H3.79606V8.48731Z"
    />
    <path
      d="M21.28 7.46616H11.728C11.4096 7.46616 11.152 7.69477 11.152 7.97673V10.4832C11.152 10.7652 11.4096 10.9938 11.728 10.9938H21.28C21.5983 10.9938 21.856 10.7652 21.856 10.4832V7.97673C21.856 7.69477 21.5983 7.46616 21.28 7.46616ZM20.7039 9.97266H12.304V8.48731H20.7039V9.97266Z"
    />
    <path
      d="M21.28 12.5091H11.728C11.4096 12.5091 11.152 12.7374 11.152 13.0197V15.5262C11.152 15.8084 11.4096 16.0367 11.728 16.0367H21.28C21.5983 16.0367 21.856 15.8084 21.856 15.5262V13.0197C21.856 12.7374 21.5983 12.5091 21.28 12.5091ZM20.7039 15.0156H12.304V13.5302H20.7039V15.0156Z"
    />
    <path
      d="M21.28 17.3291H3.22005C2.90167 17.3291 2.64404 17.5575 2.64404 17.8397V20.5097C2.64404 20.792 2.90167 21.0203 3.22005 21.0203H21.28C21.5983 21.0203 21.856 20.792 21.856 20.5097V17.8397C21.856 17.5575 21.5983 17.3291 21.28 17.3291ZM20.7039 19.9992H3.79606V18.3503H20.7039V19.9992Z"
    />
    <path
      d="M3.68187 3.54361C4.13916 3.54361 4.50988 3.21501 4.50988 2.80966C4.50988 2.40431 4.13916 2.07571 3.68187 2.07571C3.22457 2.07571 2.85385 2.40431 2.85385 2.80966C2.85385 3.21501 3.22457 3.54361 3.68187 3.54361Z"
    />
    <path
      d="M6.83072 3.54361C7.28802 3.54361 7.65873 3.21501 7.65873 2.80966C7.65873 2.40431 7.28802 2.07571 6.83072 2.07571C6.37342 2.07571 6.00271 2.40431 6.00271 2.80966C6.00271 3.21501 6.37342 3.54361 6.83072 3.54361Z"
    />
    <path
      d="M9.97961 3.54361C10.4369 3.54361 10.8076 3.21501 10.8076 2.80966C10.8076 2.40431 10.4369 2.07571 9.97961 2.07571C9.52231 2.07571 9.1516 2.40431 9.1516 2.80966C9.1516 3.21501 9.52231 3.54361 9.97961 3.54361Z"
    />
    <path
      d="M14.0742 3.32023H20.4823C20.8007 3.32023 21.0583 3.09162 21.0583 2.80966C21.0583 2.52769 20.8007 2.29908 20.4823 2.29908H14.0742C13.7558 2.29908 13.4982 2.52769 13.4982 2.80966C13.4982 3.09162 13.7558 3.32023 14.0742 3.32023Z"
    />
  </svg>
</template>
